module.exports = __webpack_public_path__ + "img/send_e-mail.d0f46246.svg";